import { render, staticRenderFns } from "./FeatureTourShell.vue?vue&type=template&id=7f6add28&scoped=true"
import script from "./FeatureTourShell.vue?vue&type=script&lang=ts"
export * from "./FeatureTourShell.vue?vue&type=script&lang=ts"
import style0 from "./FeatureTourShell.vue?vue&type=style&index=0&id=7f6add28&prod&lang=scss&scoped=true"
import style1 from "./FeatureTourShell.vue?vue&type=style&index=1&id=7f6add28&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f6add28",
  null
  
)

export default component.exports